import React, { useEffect, useState } from "react";
import "./LoanDetails4Pay.scss";
import {
  TableHead,
  TableBody,
  Table,
  TableContainer,
  TableCell,
  TableRow,
  Box,
  Pagination,
  Button,
  FormControl,
  Autocomplete,
  TextField,
  Typography,
  Grid,
  MenuItem,
  Paper,
  TablePagination,
  Accordion, 
  AccordionSummary, 
  AccordionDetails,
  Collapse,
  IconButton,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { styled } from "@mui/material/styles";
import { tableCellClasses } from "@mui/material/TableCell";
import { commonRunQuery } from "../../util/API/loans";
import CustomAlert from "../UI/CustomAlert/CustomAlert";
import { CSVLink } from "react-csv";
import pdfImage from "../../images/pdf-image.svg"
import CSVImage from "../../images/csv-file.png";
import jsPDF from "jspdf";
import "jspdf-autotable";
import autoTable from "jspdf-autotable";

const LoanDetails4Pay = ({ loanDetailsArr, userLoanPaymentPlans }) => {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [loanPage, setLoanPage] = useState(0);
  const [loanRowsPerPage, setLoanRowsPerPage] = useState(5);
  const [lateFeePage, setLateFeePage] = useState(0);
  const [lateFeeRowsPerPage, setLateFeeRowsPerPage] = useState(5);
  const [customerTabsHeight, setCustomerTabsHeight] = useState(
    window.innerHeight * 0.6
  );
  const [viewPaymentDetails, setViewPaymentDetails] = useState(false);
  const [viewLateFeeDetails, setViewLateFeeDetails] = useState(false);
  const [paymentDetails, setPaymentDetails] = useState([]);
  const [lateFeeDetails, setLateFeeDetails] = useState([]);
  const [expanded, setExpanded] = useState(null);
  const [alert, setAlert] = useState({
    showAlert: false,
    severity: "",
    header: "",
    message: "",
    onConfirm: null,
    alertType: ''
  });

  const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
    backgroundColor: "rgba(0,0,0, .1)",
    color: theme.palette.common.black,
    fontWeight: "bold",
    textAlign:"left",
    },
    [`&.${tableCellClasses.body}`]: {
    fontSize: 25,
    fontWeight: "600",
    },
  }));

  const handleChangePage = (_, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const handleLoanChangePage = (event, newPage) => {
    setLoanPage(newPage);
  };
    
  const handleLoanChangeRowsPerPage = (event) => {
    setLoanRowsPerPage(parseInt(event.target.value, 10));
    setLoanPage(0);
  };
    
  const handleLateFeeChangePage = (event, newPage) => {
    setLateFeePage(newPage);
  };
    
  const handleLateFeeChangeRowsPerPage = (event) => {
    setLateFeeRowsPerPage(parseInt(event.target.value, 10));
    setLateFeePage(0);
  };

  const handleExpand = (paymentId) => {
    setExpanded(expanded === paymentId ? null : paymentId);
  };

  const handleViewPayment = async(paymentDetails) => {
    console.log("handleViewPayment-------------",paymentDetails?.paymentid);
    try {
      const response = await commonRunQuery(236, paymentDetails?.paymentid);
      if ( response?.data?.header?.callStatus === "1" && response?.data?.header?.reccount !== "0" ) {
        const loansArray = Array.isArray(response?.data?.body?.record)
                  ? response?.data?.body?.record
                  : [response?.data?.body?.record];

        setPaymentDetails(loansArray);
        console.log("handleViewPayment_response==========",loansArray);
      } else {
        setPaymentDetails([]);
      }

    } catch (error) {
      console.log("handleViewPayment_error==========",error);
      
    }
    setViewPaymentDetails(true);
  }

  const handleViewLatePayment = async(feeDetails) => {
    try {
      const response = await commonRunQuery(239, feeDetails?.latefeeid);
      if ( response?.data?.header?.callStatus === "1" && response?.data?.header?.reccount !== "0" ) {
        const loansArray = Array.isArray(response?.data?.body?.record)
        ? response?.data?.body?.record
        : [response?.data?.body?.record];
        console.log("handleViewLatePayment_loansArray==========",loansArray);
        setLateFeeDetails(loansArray);
        setViewLateFeeDetails(true);
      } else if (response?.data?.header?.reccount == "0") {
        setLateFeeDetails([]);
        setAlert({
          showAlert: true,
          severity: "error",
          message: "No late fee details available.",
          header: "Sorry!",
        });
      } else {
        setLateFeeDetails([]);
      }
    } catch (error) {
      console.log("handleViewLatePayment_error==========",error);
    }
  }

  useEffect(()=> {
    console.log("loanDetailsArr-------------",loanDetailsArr);
    console.log("userLoanPaymentPlans-------------",userLoanPaymentPlans);
  },[loanDetailsArr])

  const handleDownloadCSV = () => {
    const header = [
      'Term No.',
      'Payment Due Date',
      'Payment Principal',
      'Payment Interest',
      'Outstanding Principal',
      'Outstanding Interest',
      'Paid Principal',
      'Paid Interest',
      'Delta Fee',
      'Status',
    ];

    const rows = userLoanPaymentPlans.map((row) => [
      row?.Loanpaymentplan?.termno,
      row?.Loanpaymentplan?.paymentduedate,
      row?.Loanpaymentplan?.paymentprincipal,
      row?.Loanpaymentplan?.paymentinterest,
      row?.Loanpaymentplan?.outstandingprincipal,
      row?.Loanpaymentplan?.outsandinginterest,
      row?.Loanpaymentplan?.paidprincipal,
      row?.Loanpaymentplan?.paidinterest,
      row?.Loanpaymentplan?.isdeltafeecalculated === '0' ? 'No' : 'Yes',
      row?.Loanpaymentplan?.status === '1'
        ? 'Outstanding'
        : row?.Loanpaymentplan?.status === '2'
        ? 'Paid'
        : 'Cancelled',
    ]);

    const csvContent = [header, ...rows].map((e) => e.join(',')).join('\n');

    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });

    const link = document.createElement('a');
    if (link.download !== undefined) {
      const url = URL.createObjectURL(blob);
      link.setAttribute('href', url);
      link.setAttribute('download', 'loan_payment_plan.csv');
      link.style.visibility = 'hidden';
      document.body.appendChild(link);
      link.click(); 
      document.body.removeChild(link);
    }
  };

  const titleRow = [
    `Loan Payment Plan Breakup`,
  ];

  const csvData = [
    // Add the title row as the first row
    titleRow,
    // Add an empty row to separate the title from the header
    [],
                         
    //These will be header columns
    [
      'Term No.',
      'Payment Due Date',
      'Payment Principal',
      'Payment Interest',
      'Outstanding Principal',
      'Outstanding Interest',
      'Paid Principal',
      'Paid Interest',
      'Delta Fee',
      'Status'
    ],

    // Add the data rows
    ...userLoanPaymentPlans.map((row) => [
      row?.Loanpaymentplan?.termno,
      row?.Loanpaymentplan?.paymentduedate,
      row?.Loanpaymentplan?.paymentprincipal,
      row?.Loanpaymentplan?.paymentinterest,
      row?.Loanpaymentplan?.outstandingprincipal,
      row?.Loanpaymentplan?.outsandinginterest,
      row?.Loanpaymentplan?.paidprincipal,
      row?.Loanpaymentplan?.paidinterest,
      row?.Loanpaymentplan?.isdeltafeecalculated === '0' ? 'No' : 'Yes',
      row?.Loanpaymentplan?.status === '1'
        ? 'Outstanding'
        : row?.Loanpaymentplan?.status === '2'
        ? 'Paid'
        : 'Cancelled',
    ]),
  ];

  const runPDF = () => {
    const doc = new jsPDF();
    const title = "Loan Payment Plan Breakup";

    // Title
    doc.setFontSize(18);
    doc.text(title, 14, 22);

    // Optional: Filter Info
    // const filters = ``;
    // doc.setFontSize(11);
    // doc.text(filters, 14, 30);

    // Table Header
    const headers = [
        [
          'Term No.',
          'Payment Due Date',
          'Payment Principal',
          'Payment Interest',
          'Outstanding Principal',
          'Outstanding Interest',
          'Paid Principal',
          'Paid Interest',
          'Delta Fee',
          'Status'
        ]
    ];

    // Table Body
    const data = userLoanPaymentPlans.map((row) => [
      row?.Loanpaymentplan?.termno,
      row?.Loanpaymentplan?.paymentduedate,
      row?.Loanpaymentplan?.paymentprincipal,
      row?.Loanpaymentplan?.paymentinterest,
      row?.Loanpaymentplan?.outstandingprincipal,
      row?.Loanpaymentplan?.outsandinginterest,
      row?.Loanpaymentplan?.paidprincipal,
      row?.Loanpaymentplan?.paidinterest,
      row?.Loanpaymentplan?.isdeltafeecalculated === '0' ? 'No' : 'Yes',
      row?.Loanpaymentplan?.status === '1'
        ? 'Outstanding'
        : row?.Loanpaymentplan?.status === '2'
        ? 'Paid'
        : 'Cancelled',
    ]);

    // Generate PDF Table
    autoTable(doc, {
        head: headers,
        body: data,
        startY: 38,
        styles: {
            fontSize: 8,
            cellPadding: 2,
        },
        headStyles: {
            fillColor: [22, 160, 133],
        }
    });

    // Save PDF
    doc.save("LoanPaymentPlanBreakup.pdf");
  };

  return (
    <Box
      sx={{
          padding: "0px 22px",
          // marginBottom: "60px",
          height: "calc(75vh - 80px)",
          overflow: "hidden",
          overflowY:"auto"
      }}
      className="loan-details-container"
    >
      {
        viewPaymentDetails == true ?
        <Box>
          <Box className="d-flex justify-content-between">
            <Typography
              sx={{
                fontFamily: "'Nunito'",
                fontStyle: "normal",
                fontWeight: 500,
                fontSize: "21.4825px",
                color: "#3A3A3A",
              }}
              className=""
            >
              View Payment Details
            </Typography>
            <Box>
            <Button
              className="fs-size-12 paiy-blue text-white"
              variant="contained"
              color="primary"
              onClick={() => setViewPaymentDetails(false)}
            >
                Return
            </Button>
            </Box>
          </Box>

          <Box className="mt-4">
            {paymentDetails && paymentDetails?.length >0 && paymentDetails.map((payment, index) => (
              <Accordion key={index} className="mb-2 mt-4">
                {/* Accordion Header */}
                <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                  <Typography variant="h6">
                    Loan ID: {payment.loanapplied.loanid} - UGX {payment.loanapplied.totalamountapplied}
                  </Typography>
                </AccordionSummary>
      
                {/* Accordion Details - Table */}
                <AccordionDetails>
                  <TableContainer>
                    <Table size="medium">
                      <TableHead>
                        <TableRow>
                          <StyledTableCell><strong>Payment ID</strong></StyledTableCell>
                          <StyledTableCell><strong>Amount Applied</strong></StyledTableCell>
                          <StyledTableCell><strong>Currency</strong></StyledTableCell>
                          <StyledTableCell><strong>Fees</strong></StyledTableCell>
                          <StyledTableCell><strong>Status</strong></StyledTableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        <TableRow>
                          <TableCell align="center">{payment.loanapplied.paymentid}</TableCell>
                          <TableCell align="center">{payment.loanapplied.amountapplied}</TableCell>
                          <TableCell align="center">{payment.loanapplied.currcode}</TableCell>
                          <TableCell align="center">{payment.loanapplied.feesapplied}</TableCell>
                          <TableCell align="center">
                            {payment.loanapplied.status === "0" ? "Fully Paid" : payment.loanapplied.status === "1" ? "Fully Paid" : "Cancelled"}
                          </TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                  </TableContainer>
                </AccordionDetails>
              </Accordion>
            ))}
          </Box>
        </Box>
        : viewLateFeeDetails == true ?
        <Box>
          <Box className="d-flex justify-content-between">
            <Typography
              sx={{
                fontFamily: "'Nunito'",
                fontStyle: "normal",
                fontWeight: 500,
                fontSize: "21.4825px",
                color: "#3A3A3A",
              }}
              className=""
            >
              View Late Fee Details
            </Typography>
            <Box>
              <Button
                className="fs-size-12 paiy-blue text-white"
                variant="contained"
                color="primary"
                onClick={() => setViewLateFeeDetails(false)}
              >
                  Return
              </Button>
            </Box>
          </Box>

          <Box className="mt-4">
            {lateFeeDetails && lateFeeDetails?.length >0 && lateFeeDetails.map((lateFee, index) => (
              <Accordion key={index} className="mb-2 mt-4">
                <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                  <Typography variant="h6">
                    Apply ID: {lateFee?.loanlatefeesapplied?.applyid} - UGX {lateFee?.loanlatefeesapplied?.amountapplied}
                  </Typography>
                </AccordionSummary>
      
                <AccordionDetails>
                  <TableContainer>
                    <Table size="medium">
                      <TableHead>
                        <TableRow>
                          <StyledTableCell><strong>Payment ID</strong></StyledTableCell>
                          <StyledTableCell><strong>Amount Applied</strong></StyledTableCell>
                          <StyledTableCell><strong>Currency</strong></StyledTableCell>
                          <StyledTableCell><strong>Status</strong></StyledTableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        <TableRow>
                          <TableCell align="center">{lateFee?.loanlatefeesapplied.paymentid}</TableCell>
                          <TableCell align="center">{lateFee?.loanlatefeesapplied.amountapplied}</TableCell>
                          <TableCell align="center">{lateFee?.loanlatefeesapplied.currcode}</TableCell>
                          <TableCell align="center">
                            {lateFee?.loanlatefeesapplied.status === "0" ? "Fully Paid" : lateFee?.loanlatefeesapplied.status === "1" ? "Fully Paid" : "Cancelled"}
                          </TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                  </TableContainer>
                </AccordionDetails>
              </Accordion>
            ))}
          </Box>
        </Box>
        :
        <Box>
          {/* Payment Plan Dteails */}
          <Box
            sx={{
                flex: "1",
                maxWidth: "100%",
                overflow: "hidden",
                padding: "15px",
                backgroundColor: "white",
                display: "flex",
                flexDirection: "column", // Stack loan details & table
                height: "100%", // Ensure it does not overflow
            }}
          >
            <Box className="d-flex justify-content-between mb-2">
              <Typography variant="subtitle1" sx={{ fontWeight: "bold" }}>Loan Payment Plan Breakup</Typography>
              {/* <Button
                className="fs-size-12 paiy-blue text-white"
                variant="contained"
                color="primary"
                onClick={handleDownloadCSV}
              >
                  Print Payment Plan
              </Button> */}
              <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
                <Box>
                    <CSVLink
                        data={csvData}
                        filename={`LoanAgeAnalysisReport.csv`}
                    >
                        <IconButton
                            sx={{
                                width: 40,
                                height: 40,
                                color: "#6c757d",
                                "&:hover": {
                                backgroundColor: "rgba(108, 117, 125, 0.1)",
                                },
                            }}
                        >
                            <img src={CSVImage} style={{ width:"48px" }} loading="lazy" />
                        </IconButton>
                    </CSVLink>{" "}
                </Box>

                <Box>
                    <IconButton
                        onClick={runPDF}
                        sx={{
                            width: 40,
                            height: 40,
                            color: "#6c757d",
                            backgroundColor: "transparent",
                            "&:hover": {
                                backgroundColor: "rgba(108, 117, 125, 0.1)",
                            },
                        }}
                    >
                        <img src={pdfImage} alt="PDF" loading="lazy" />
                    </IconButton>
                </Box>
            </Box>

            </Box>

            <TableContainer >
              <Table>
                  <TableHead>
                      <TableRow>
                          <StyledTableCell>Term No.</StyledTableCell>
                          <StyledTableCell sx={{ textAlign:"center !important" }}>Payment Due Date</StyledTableCell>
                          <StyledTableCell sx={{ textAlign:"right !important" }}>Payment Principal</StyledTableCell>
                          <StyledTableCell sx={{ textAlign:"right !important" }}>Payment Interest</StyledTableCell>
                          <StyledTableCell sx={{ textAlign:"right !important" }}>Outstanding Principal</StyledTableCell>
                          <StyledTableCell sx={{ textAlign:"right !important" }}>Outstanding Interest</StyledTableCell>
                          <StyledTableCell sx={{ textAlign:"right !important" }}>Paid Principal</StyledTableCell>
                          <StyledTableCell sx={{ textAlign:"right !important" }}>Paid Interest</StyledTableCell>
                          <StyledTableCell sx={{ textAlign:"center !important" }}>Delta Fee</StyledTableCell>
                          <StyledTableCell sx={{ textAlign:"center !important" }}>Status</StyledTableCell>
                      </TableRow>
                  </TableHead>
                  <TableBody>
                  {
                    userLoanPaymentPlans && userLoanPaymentPlans.length > 0 ? (userLoanPaymentPlans.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row, index) => (
                      <TableRow key={index}>
                        <TableCell align="center" className="">
                            <div>{row?.Loanpaymentplan?.termno}</div>
                        </TableCell>
                        <TableCell align="center" className="">
                            <div>{row?.Loanpaymentplan?.paymentduedate}</div>
                        </TableCell>
                        <TableCell align="right" className="">
                            <div>{Number(row?.Loanpaymentplan?.paymentprincipal).toLocaleString("en-US", { minimumFractionDigits: 2 })}</div>
                        </TableCell>
                        <TableCell align="right" className="">
                            <div>{Number(row?.Loanpaymentplan?.paymentinterest).toLocaleString("en-US", { minimumFractionDigits: 2 })}</div>
                        </TableCell>
                        <TableCell align="right" className="">
                            <div>{Number(row?.Loanpaymentplan?.outstandingprincipal).toLocaleString("en-US", { minimumFractionDigits: 2 })}</div>
                        </TableCell>
                        <TableCell align="right" className="">
                            <div>{Number(row?.Loanpaymentplan?.outsandinginterest).toLocaleString("en-US", { minimumFractionDigits: 2 })}</div>
                        </TableCell>
                        <TableCell align="right" className="">
                            <div>{Number(row?.Loanpaymentplan?.paidprincipal).toLocaleString("en-US", { minimumFractionDigits: 2 })}</div>
                        </TableCell>
                        <TableCell align="right" className="">
                            <div>{Number(row?.Loanpaymentplan?.paidinterest).toLocaleString("en-US", { minimumFractionDigits: 2 })}</div>
                        </TableCell>
                        <TableCell align="center" className="">
                            <div>{row?.Loanpaymentplan?.isdeltafeecalculated === "0" ? "No" : "Yes" }</div>
                        </TableCell>
                        <TableCell align="center" className="">
                            <div>{row?.Loanpaymentplan?.status === "1" ? "Outstanding" : row?.Loanpaymentplan?.status === "2" ? "Paid" : "Cancelled" }</div>
                        </TableCell>
                      </TableRow>
                  ))
                  ) : (
                      <TableRow>
                          <TableCell align="center" colSpan={8}>
                              <Typography variant="body1" color="textSecondary">
                              No data available
                              </Typography>
                          </TableCell>
                          </TableRow>
                      )}
                    </TableBody>
              </Table>
            </TableContainer>
            <TablePagination
              rowsPerPageOptions={[5, 10, 20]}
              component="div"
              count={userLoanPaymentPlans.length}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />

          </Box>

          <Box
            className="mt-4"
            sx={{
              display: "flex",
              flexDirection: "row",
              gap: "16px",
              height: "100%",
            }}
          >
            {/* Left Side: Loan Details & Table */}
            <Box
              sx={{
                  flex: "1",
                  maxWidth: "50%",
                  overflow: "hidden",
                  padding: "15px",
                  backgroundColor: "white",
                  display: "flex",
                  flexDirection: "column", // Stack loan details & table
                  height: "100%", // Ensure it does not overflow
              }}
            >
              <Typography variant="subtitle1" sx={{ fontWeight: "bold", marginTop: "20px" }}>Outstaning Loan Payments</Typography>
              {
                loanDetailsArr?.length === 0 ? (
                  <Typography>No loan data available.</Typography>
                ) :
                loanDetailsArr?.map((loan) => (
                  <Box key={loan?.loanid}>
                    <TableContainer>
                      <Table>
                          <TableHead>
                              <TableRow>
                                  <StyledTableCell>Date</StyledTableCell>
                                  <StyledTableCell>Apply ID</StyledTableCell>
                                  <StyledTableCell sx={{ textAlign:"right !important" }}>Amount Paid</StyledTableCell>
                                  <StyledTableCell>Payment Id</StyledTableCell>
                              </TableRow>
                          </TableHead>
                          <TableBody>
                              {loan?.normalPayments?.length > 0 ? (
                                  loan?.normalPayments?.map((payment) => (
                                      <TableRow key={payment.applyid}>
                                          <TableCell align="left">{payment?.paymentdate}</TableCell>
                                          <TableCell align="left">{payment?.applyid}</TableCell>
                                          <TableCell align="right">{Number(payment?.amountapplied).toLocaleString("en-US", { minimumFractionDigits: 2 })}</TableCell>
                                          <TableCell onClick={()=>handleViewPayment(payment)} className="payment-id" align="left">{payment.paymentid}</TableCell>
                                      </TableRow>
                                  ))
                              ) : (
                                  <TableRow>
                                      <TableCell align="center" colSpan={4}>No outstanding payments</TableCell>
                                  </TableRow>
                              )}
                          </TableBody>
                      </Table>
                    </TableContainer>
                    <TablePagination
                      rowsPerPageOptions={[5, 10, 25]}
                      component="div"
                      count={paymentDetails?.length || 0}
                      rowsPerPage={loanRowsPerPage}
                      page={loanPage}
                      onPageChange={handleLoanChangePage}
                      onRowsPerPageChange={handleLoanChangeRowsPerPage}
                    />
                  </Box>
                ))
              }
            </Box>

            {/* Right Side */}
            <Box
              sx={{
                  flex: 1,
                  minWidth: "50%",
                  backgroundColor: "white",
                  overflow: "auto",
                  marginLeft: "15px",
                  height: "100%",
                  padding: "15px",
              }}
            >
              <Typography variant="subtitle1" sx={{ fontWeight: "bold", marginTop: "20px" }}>Late Fee Payment</Typography>
              {
                loanDetailsArr.length === 0 ? (
                  <Typography>No loan data available.</Typography>
                ) :
                loanDetailsArr.map((loan) => (
                  <Box key={loan.loanid}>
                    <TableContainer>
                      <Table>
                          <TableHead>
                              <TableRow>
                                <StyledTableCell>Date</StyledTableCell>
                                <StyledTableCell>Late Fee ID</StyledTableCell>
                                <StyledTableCell sx={{ textAlign:"right !important" }}>Late Fee</StyledTableCell>
                                <StyledTableCell sx={{ textAlign:"right !important" }}>Paid Amount</StyledTableCell>
                                <StyledTableCell sx={{ textAlign:"right !important" }}>Outstanding Fee</StyledTableCell>
                              </TableRow>
                          </TableHead>
                          <TableBody>
                            {loan.lateFees.length > 0 ? (
                              loan.lateFees.slice(lateFeePage * lateFeeRowsPerPage, lateFeePage * lateFeeRowsPerPage + lateFeeRowsPerPage).map((fee) => (
                              // loan.lateFees.slice(lateFeePage * lateFeeRowsPerPage, lateFeePage * lateFeeRowsPerPage + lateFeeRowsPerPage).map((fee) => (
                                // loan.lateFees.map((fee) => (
                                  <TableRow key={fee.latefeeid}>
                                    <TableCell align="left">{fee?.transdate}</TableCell>
                                    <TableCell align="left" className="late-fee-id" onClick={()=>handleViewLatePayment(fee)}> {fee?.latefeeid}</TableCell>
                                    <TableCell align="right">{Number(fee?.latefee).toLocaleString("en-US", { minimumFractionDigits: 2 })}</TableCell>
                                    <TableCell align="right">{Number(fee?.paidamount).toLocaleString("en-US", { minimumFractionDigits: 2 })}</TableCell>
                                    <TableCell align="right">{Number(fee?.outstandingfee).toLocaleString("en-US", { minimumFractionDigits: 2 })}</TableCell>
                                  </TableRow>
                                ))
                            ) : (
                                <TableRow>
                                    <TableCell align="center" colSpan={5}>No late fee payments</TableCell>
                                </TableRow>
                            )}
                        </TableBody>
                      </Table>
                    </TableContainer>
                    <TablePagination
                      rowsPerPageOptions={[5, 10, 25]}
                      component="div"
                      count={lateFeeDetails?.length || 0}
                      rowsPerPage={lateFeeRowsPerPage}
                      page={lateFeePage}
                      onPageChange={handleLateFeeChangePage}
                      onRowsPerPageChange={handleLateFeeChangeRowsPerPage}
                    />
                  </Box>
                ))
              }
            </Box>
          </Box>
        </Box>
      }

      <CustomAlert
        severity={alert.severity}
        show={alert.showAlert}
        header={alert.header}
        message={alert.message}
        onClick={() => {
          setAlert({ ...alert, showAlert: false });
        }}
        alertType={alert.alertType}
        confirmButton={alert.onConfirm}
        autoclose={alert.severity === "error" ? false : true}
      />
    </Box>
  );
};

export default LoanDetails4Pay;
